/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingDto } from '../../models/setting-dto';

export interface ApiAdminSettingsGet$Params {
}

export function apiAdminSettingsGet(http: HttpClient, rootUrl: string, params?: ApiAdminSettingsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SettingDto>>> {
  const rb = new RequestBuilder(rootUrl, apiAdminSettingsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SettingDto>>;
    })
  );
}

apiAdminSettingsGet.PATH = '/api/Admin/settings';
